import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

// Action types

export type InitBlockActionPayload = {
  id: string;
  filters: unknown;
  visibleFilters: Array<string>;
};

export type SetFiltersActionPayload = {
  id: string;
  filters: unknown;
};
export type SetVisibleFiltersActionPayload = {
  id: string;
  visibleFilters: Array<string>;
};
export type SetOffsetActionPayload = {
  id: string;
  offset: number;
};

// State types
export type TableBlockData = {
  id: string;
  filters: unknown;
  visibleFilters: Array<string>;
  offset: number;
};
export interface BlockState {
  [key: string]: TableBlockData;
}

// Initial State
const initialState: BlockState = {};

// REDUCERS
export const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    initBlock: (state, action: PayloadAction<InitBlockActionPayload>) => {
      const { id, visibleFilters, filters } = action.payload;
      if (!state[id]) {
        state[id] = { id, filters, visibleFilters, offset: 0 };
      }
    },
    setFilters: (state, action: PayloadAction<SetFiltersActionPayload>) => {
      const { id, filters } = action.payload;
      if (state[id]) {
        state[id].filters = filters;
      }
    },
    setVisibleFilters: (state, action: PayloadAction<SetVisibleFiltersActionPayload>) => {
      const { id, visibleFilters } = action.payload;
      if (state[id]) {
        state[id].visibleFilters = visibleFilters;
      }
    },
    setOffset: (state, action: PayloadAction<SetOffsetActionPayload>) => {
      const { id, offset } = action.payload;
      if (state[id]) {
        state[id].offset = offset;
      }
    },
  },
});

// ACTIONS
export const { initBlock, setFilters, setOffset, setVisibleFilters } = tableSlice.actions;

// SELECTORS
export const getTableDataList = createSelector(
  (state: RootState) => state.table,
  (tableData) => tableData
);

export const getTableBlockData = (id: string) =>
  createSelector(
    getTableDataList,
    (list) =>
      list[id] || {
        id: '',
        visibleFilters: [] as Array<string>,
        offset: 0,
      }
  );

export default tableSlice.reducer;
